import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const navItems = [
  { id: 'dashboard', icon: 'FiGrid', label: 'Dashboard' },
  { id: 'chores', icon: 'FiCheckSquare', label: 'Tasks' },
  { id: 'maintenance', icon: 'FiTool', label: 'Hardware' },
  { id: 'calendar', icon: 'FiCalendar', label: 'Schedule' },
  { id: 'demo', icon: 'FiPlayCircle', label: 'Live Demo' },
  { id: 'settings', icon: 'FiSettings', label: 'Settings' }
];

export const Sidebar = ({ activeTab, setActiveTab }) => (
  <div className="hidden lg:flex flex-col w-64 h-full bg-slate-950 border-r border-slate-800/50 p-4">
    <div className="flex items-center space-x-3 mb-8 px-2 mt-4">
      <div className="w-8 h-8 bg-teal-500 rounded-lg flex items-center justify-center neon-border-teal">
        <SafeIcon icon="FiHome" className="text-slate-950 font-bold" />
      </div>
      <span className="text-xl font-bold tracking-tight text-white neon-text-teal">HomePulse</span>
    </div>
    
    <nav className="flex-1 space-y-2">
      {navItems.map(item => (
        <button
          key={item.id}
          onClick={() => setActiveTab(item.id)}
          className={`w-full flex items-center space-x-3 px-4 py-3 rounded-xl transition-all relative ${
            activeTab === item.id ? 'text-teal-400 bg-slate-900/80 font-medium' : 'text-slate-500 hover:text-slate-300 hover:bg-slate-900/40'
          }`}
        >
          {activeTab === item.id && (
            <motion.div layoutId="activeNav" className="absolute left-0 w-1 h-6 bg-teal-500 rounded-r-full shadow-[0_0_8px_rgba(45,212,191,0.8)]" />
          )}
          <SafeIcon icon={item.icon} className="text-lg" />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  </div>
);

export const BottomNav = ({ activeTab, setActiveTab }) => (
  <div className="lg:hidden fixed bottom-6 left-4 right-4 glass-panel rounded-2xl p-2 z-50 flex justify-around items-center overflow-x-auto scrollbar-hide">
    {navItems.map(item => (
      <button
        key={item.id}
        onClick={() => setActiveTab(item.id)}
        className={`flex flex-col items-center justify-center p-2 rounded-xl transition-all min-w-[60px] h-14 ${
          activeTab === item.id ? 'text-teal-400' : 'text-slate-500'
        }`}
      >
        {activeTab === item.id && (
          <motion.div layoutId="activeBottom" className="absolute inset-0 bg-teal-500/10 rounded-xl neon-border-teal" />
        )}
        <SafeIcon icon={item.icon} className="text-xl relative z-10" />
        <span className="text-[10px] mt-1 relative z-10 font-medium whitespace-nowrap">{item.label}</span>
      </button>
    ))}
  </div>
);